import { twMerge } from 'tailwind-merge';
import { classes } from './utils';

export interface FormHeadingProps {
  className?: string;
  subtitle: string;
  title: string;
}

export default function FormHeading({
  className,
  subtitle,
  title,
}: FormHeadingProps) {
  return (
    <div className={twMerge(classes.wrapper, className)}>
      <div className={classes.title}>{title}</div>
      <div className={classes.subtitle}>{subtitle}</div>
    </div>
  );
}
